import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import IconButton from '../common/base/IconButton.vue';
import AIIcon from '../common/icons/AIIcon.vue';
import AITranscription from '../common/icons/AITranscription.vue';
import AISubtitlesIcon from '../common/icons/AISubtitles.vue';
import { roomService } from '../../services';
import { useI18n } from '../../locales';
import SvgIcon from '../common/base/SvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AIControl',
  emits: ['show-overlay'],
  setup(__props, { emit }) {

const { t } = useI18n();

const AIControlConfig = roomService.getComponentConfig('AIControl');
const { basicStore } = roomService;

const isSidebarOpen = computed(() => basicStore.isSidebarOpen);
const sidebarName = computed(() => basicStore.sidebarName);
const showToolBox = ref(false);
const showSubtitles = ref(false);

watch(isSidebarOpen, newValue => {
  showToolBox.value = newValue && false;
});

function toggleToolBox() {
  showToolBox.value = !showToolBox.value;
}

const toggleAITranscription = () => {
  if (
    basicStore.setSidebarOpenStatus &&
    basicStore.sidebarName === 'aiTranscription'
  ) {
    basicStore.setSidebarOpenStatus(false);
    basicStore.setSidebarName('');
    return;
  }
  basicStore.setSidebarOpenStatus(true);
  basicStore.setSidebarName('aiTranscription');
  showToolBox.value = false;
};

const openAISubtitles = () => {
  showSubtitles.value = !showSubtitles.value;
  showToolBox.value = false;
  emit('show-overlay', {
    name: 'AISubtitlesOverlay',
    visible: showSubtitles.value,
  });
};

return { __sfc: true,t, emit, AIControlConfig, basicStore, isSidebarOpen, sidebarName, showToolBox, showSubtitles, toggleToolBox, toggleAITranscription, openAISubtitles, IconButton, AIIcon, AITranscription, AISubtitlesIcon, SvgIcon }
}

})